import React from 'react';
import LegalLayout from '../components/LegalLayout';

const Accessibility: React.FC = () => {
  return (
    <LegalLayout>
      <article className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
        <h1 className="text-3xl md:text-4xl font-bold text-text-dark mb-8">
          Accessibility Statement
        </h1>

        <div className="prose prose-lg max-w-none text-text-light">
          <p className="mb-6">
            This accessibility statement applies to the Dry Eye Solutions Ltd website{' '}
            <a href="https://www.dryeye.co" className="text-primary hover:text-primary-dark">
              www.dryeye.co
            </a>{' '}
            and, where relevant, to Comfort - Dry Eye App.
          </p>
          <p className="mb-6">
            Dry Eye Solutions Ltd is committed to making our website and app accessible, in
            line with recognised good practice and our responsibilities under the Equality
            Act 2010.
          </p>

          <h2 className="text-xl font-bold text-text-dark mt-8 mb-4">
            How accessible this website is
          </h2>
          <p className="mb-6">
            We have completed an accessibility audit against WCAG 2.2 AA, and passed via
            self assessment. Additionally it scores an Accessibility Impact (AIM)
            assessment report score 9.9/10 (28th July 2026).
          </p>

          <h2 className="text-xl font-bold text-text-dark mt-8 mb-4">
            Feedback and contact information
          </h2>
          <p className="mb-6">
            If you find any problem not listed on this page, or think we&apos;re not
            meeting accessibility requirements, please contact us at{' '}
            <a href="mailto:info@dryeye.co" className="text-primary hover:text-primary-dark">
              info@dryeye.co
            </a>
            .
          </p>
        </div>
      </article>
    </LegalLayout>
  );
};

export default Accessibility;
